// extracted by mini-css-extract-plugin
module.exports = {"box":"BasicModal_box__W7z-V","title":"BasicModal_title__2n2Yw","wrapper":"BasicModal_wrapper__9AHQ5"};